import { makeStyles } from '@mui/styles';

import flags from './flags.png';
import flagIcons from './flagsIcon';

const styles = (theme) => ({
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column !important',

  },

  fieldBase: ({ error }) => {

    function border () {
      if (error) {
        return '1px solid #B3261E';
      }
      return '1px solid #DEDDDF';
    }
    return  {
       width: '100%',
       display: 'flex',
       height: '40px',
       padding: '6px',
       
       alignItems: 'center',
       boxSizing: 'border-box',
       border: border(),
       borderRadius: '8px',
    };
  },

  button: {
    display: 'flex',
  },

  textInput: {
    border: 'none 0px',
    backgroundColor: 'transparent',
    fontSize: '14px',
    fontFamily: 'GothamRounded',
    '&:focus': {
      border: '0',
      outline: 'none 0px',
    },

    '&::placeholder': {
      color: '#66666666',
      fontSize: '14px',
      fontFamily: 'GothamRounded-book',
    },

    '&:-internal-autofill-selected': {
      backgroundColor: '#FFFFFF00 !important',
    },

    '&:-webkit-autofill': {
      backgroundColor: '#FFFFFF00 !important',
    },
    
    '&:-webkit-autofill:focus': {
      backgroundColor: '#FFFFFF00 !important',
    },

    '&:-webkit-autofill:active': {
      backgroundColor: '#FFFFFF00 !important',
    },

    '&:-webkit-autofill:hover': {
      backgroundColor: '#FFFFFF00 !important',
    },
    
  },

  downIcon: {
    color: '#737373',
    pointerEvents: 'none',
  },

  listBase: ({ inputSize }) => {
    function getWidth () {
      if (!inputSize) {
        return '316px';
      }
      return `${inputSize.width}px`;
    }
    const style = {
      position: 'relative',
      width: getWidth(),
      maxWidth: getWidth(),
      left: '-5px',
      display: 'flex',
      height: '250px',
      maxHeight: '250px',
      backgroundColor: '#FFFFFF',
      justifyContent: 'center',
      boxShadow: '0px 2px 5px #00000020',
    }
    return style;
  },

  listParent: {
    display: 'flex',
    
    width: '100%',
    maxHeight: '250px',

    overflowY: 'auto',
    overflowX: 'hidden',

    // Firefox scrollbar styling
    scrollbarColor: 'rgba(220, 220, 220, 0.678) transparent',
    scrollbarWidth: 'thin',

    // Webkit (Chrome, Safari, Edge) scrollbar styling
    '&::-webkit-scrollbar': {
        width: '6px',
        backgroundColor: 'transparent',
    },
    '&::-webkit-scrollbar-track': {
        backgroundColor: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
        backgroundColor: 'rgba(220, 220, 220, 0.678)',
        borderRadius: '3px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
        backgroundColor: 'rgba(180, 180, 180, 0.8)',
    },
  },

  list: {
      display: 'block',
      width: 'calc(100%)',
      height: 'calc(100% + 60px)',
      // border: '1px solid #FF0000',
      borderRadius: '8px',
  },

  listItem: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    height: '30px',
    backgroundColor: '#FFFFFF',
    cursor: 'pointer',
    pointerEvents: 'auto',

    borderRadius: '4px',
    
    '&:hover': {
      backgroundColor: '#F1F1F1',
    },
 
    '&[data-selected="true"]': {
      backgroundColor: '#F1F1F1',
    },
  },

  listItemText: {
    fontSize: '11.5px',
    marginLeft: '8px',
    pointerEvents: 'none',

    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    textAlign: 'center',
    textTransform: 'none',
  },

  listItemCode: {
    fontSize: '11.5px',
    marginLeft: '8px',
    pointerEvents: 'none',
    color: '#737373',
  },
  
  helperText: ({ error, helperText }) => {
    const style = {
      color: !error? '#00000099' : '#B3261E',
      fontSize: '10px',
      height: '22px',
      lineHeight: '20px',
      fontWeight: 'bold',
      margin: '4px 0px 0px',
      fontFamily: 'GothamRounded',
    };
    
    if (!helperText) {
      style.height = '0px';
    }
    return style;
  },

  fieldLabel: () => {
    const style = {
      fontSize: '12px',
      lineHeight: '16px',
      fontWeight: 'bold',
      marginBottom: '4px',
    };
    return style;
  },
 
  flags: () => {
 
    return {
      display: 'inline-block',
      background: `url(${flags})`,
      height: '16px',
      width: '16px',
      lineHeight:'16px',
      content: '',
      verticalAlign: 'middle',
      marginRight: '3px',
      pointerEvents: 'none',
     
    };
  },
  ...flagIcons,
  
});

export default styles;
export const useStyles = makeStyles(styles);
